import { Text, Link } from "@chakra-ui/react";
import React from "react";

export const UnexpectedErrorString =
  "An unexpected error has occurred. Please try again later.";

export const UnexpectedError = (): JSX.Element => (
  <Text color="red.500">
    {UnexpectedErrorString}
    <p>
      If issues persist, please contact us at{" "}
      <Link fontWeight="bold" href="mailto:hello@syla.com.au">
        hello@syla.com.au
      </Link>
      .
    </p>
  </Text>
);
